import { render } from "./ViewAuction.vue?vue&type=template&id=394df2c8&scoped=true"
import script from "./ViewAuction.vue?vue&type=script&lang=js"
export * from "./ViewAuction.vue?vue&type=script&lang=js"

import "./ViewAuction.vue?vue&type=style&index=0&id=394df2c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394df2c8"]])

export default __exports__